<template>
  <FKBreadCrumb :page="$t('page.create')" :title="$t('page.create_center')" >
    <FKBreadCrumbItem :page="$t('page.centers')" to="/system-centers"/>
  </FKBreadCrumb>
  <CenterForm />
</template>

<script lang="ts">
import { defineComponent } from "vue";

import CenterForm from "@/components/FK/Center/CenterForm.vue";
import FKBreadCrumb from "@/components/Widgets/BreadCrumb/FKBreadCrumb.vue";
import FKBreadCrumbItem from "@/components/Widgets/BreadCrumb/FKBreadCrumbItem.vue";

export default defineComponent({
  name: "CreateCenterPage",
  components: {
    FKBreadCrumb,
    FKBreadCrumbItem,
    CenterForm,
  },
});
</script>